module.exports = __webpack_public_path__ + "static/media/ourstories-screen-three-people.c22940e4.png";